import { Controller, useFormContext, useFormState } from 'react-hook-form';

import { ErrorMessage } from './ErrorMessage';
import { InputLabel } from '../ui/InputLabel';
import MaskedInput from '../ui/MaskedInput';

interface IProps {
  name: string;
  label?: string;
}

export const CPFOrCPNJInput = ({ name, label }: IProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });
  const message = errors[name]?.message as string | undefined;

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field }) => (
          <MaskedInput
            id={name}
            mask='cpfOrCnpj'
            placeholder='000.000.000-00 ou 00.000.000/0000-00'
            message={message ? 'error' : ''}
            maxLength={18}
            {...field}
          />
        )}
      />
      <ErrorMessage fieldName={name} />
    </>
  );
};
